import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Él se dará cuenta de que lo estoy auditando?',
  answer: 'No. El sistema está diseñado para observar comportamientos naturales durante una conversación normal. No hay preguntas raras ni actitudes que delaten el protocolo.'
}, {
  question: '¿Qué pasa si es un buen tipo pero falla algunos puntos?',
  answer: 'La Tabla de Decisión Final contempla eso. Hay señales críticas y señales menores. El sistema te da el contexto para distinguir una falla puntual de un patrón de alerta real.'
}, {
  question: '¿Sirve para relaciones que ya empezaron?',
  answer: 'Sí. Puedes aplicar los sensores de forma retroactiva para evaluar comportamientos que ya observaste. Varias usuarias lo hicieron así y tomaron decisiones más claras.'
}, {
  question: '¿Necesito experiencia en psicología?',
  answer: 'No. El sistema es binario: pasó o no pasó. No necesitas interpretar ni analizar. Solo observar y marcar. Diseñado para cualquier mujer desde la primera cita.'
}, {
  question: '¿Cómo recibo el producto?',
  answer: 'Inmediatamente después del pago recibirás un correo con el enlace de descarga de todos los materiales en formato digital. Acceso instantáneo, disponible 24/7.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. 30 días de garantía total. Si aplicaste el sistema y no te dio claridad, te devolvemos el 100% sin preguntas ni formularios.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-35">
      <span className="inline-block bg-[var(--accent)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-4 uppercase" data-id="element-36">
        PREGUNTAS FRECUENTES
      </span>

      <h2 className="text-[clamp(24px,6vw,36px)] font-extrabold leading-tight" data-id="element-37">
        Resolvemos las dudas.
      </h2>

      <div className="mt-6" data-id="element-38">
        {faqs.map((faq, index) => <div key={index} className="bg-[var(--card)] rounded-xl mb-3 overflow-hidden" data-id="element-39">
            <button onClick={() => toggleFAQ(index)} className="w-full bg-transparent border-none text-white px-5 py-4 text-left text-[15px] font-semibold cursor-pointer flex justify-between items-center gap-4" data-id="element-40">
              <span data-id="element-41">{faq.question}</span>
              <ChevronDownIcon className={`text-[var(--red2)] flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} size={16} data-id="element-42" />
            </button>

            <AnimatePresence data-id="element-43">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-44">
                  <div className="px-5 pb-5" data-id="element-45">
                    <p className="text-[var(--muted)] text-sm leading-relaxed" data-id="element-46">
                      {faq.answer}
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}